"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var Reply = function Reply(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "reply"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.28 19.52c0.024 0.005 0.052 0.007 0.080 0.007s0.056-0.003 0.083-0.008l-0.003 0c0.322-0.075 0.559-0.36 0.56-0.7v-0c0-10.12-6.32-12.94-9.52-13.3v-4.34c-0.009-0.39-0.328-0.704-0.72-0.704-0.185 0-0.353 0.070-0.481 0.184l0.001-0.001-9.060 8.32c-0.136 0.137-0.22 0.326-0.22 0.535 0 0.002 0 0.004 0 0.005v-0c0.002 0.207 0.094 0.393 0.239 0.519l0.001 0.001 9.040 8.12c0.12 0.107 0.279 0.173 0.453 0.173 0.112 0 0.217-0.027 0.311-0.075l-0.004 0.002c0.257-0.105 0.436-0.351 0.44-0.639v-4.281c3.652 0.213 6.728 2.472 8.116 5.639l0.024 0.061c0.1 0.276 0.356 0.472 0.659 0.48l0.001 0zM9.76 11.9c-0.398 0-0.72 0.322-0.72 0.72v0 3.4l-7.26-6.5 7.26-6.66v3.32c0 0.398 0.322 0.72 0.72 0.72v0c2.18 0 7.48 1.7 8.58 9-2.061-2.452-5.13-4-8.56-4-0.007 0-0.014 0-0.021 0h0.001z"
  }));
};
var _default = exports["default"] = Reply;